module.exports = __webpack_public_path__ + "static/cinema.3856f20e.png";